export class IdListDto {
    ids: string[] = [];

    static fromIds(ids: string[]) : IdListDto {
        const dto = new IdListDto();
        dto.ids = ids;

        return dto;
    }
 }